import React, {
  useMemo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  InputStyled,
  InputContainer,
  InputLabel,
  CircularProgressStyled,
} from "./InputUnform.styles";
import InputMask from "react-input-mask";
import { useField } from "@unform/core";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BaseTextFieldProps } from "@mui/material/TextField";

export interface InputUnformPropsI extends BaseTextFieldProps {
  placeholder?: string;
  icon?: {
    direction: "start" | "end";
    icon: any;
  };
  mask?: string;
  enabled?: boolean;
  type?: "text" | "password";
  labelText?: string;
  name: string;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
  disabled?: boolean;
  focus?: boolean;
  handleFocus?(): void;
  onKeyPress?(event: React.KeyboardEvent<HTMLInputElement>): void;
  maxLength?: number;
  filled?: boolean;
}
export const InputUnform: React.FC<InputUnformPropsI> = (handler) => {
  const inputRef = useRef(null);
  const {
    icon,
    enabled = true,
    mask = "",
    placeholder,
    labelText,
    name,
    onChange,
    disabled,
    onKeyPress,
    type,
    maxLength,
    filled = false,
    onBlur,
  } = handler;
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const handleClickShowPassword = useCallback(() => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  }, [values]);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  const IconInput: React.FC = useCallback(() => {
    if (error === "success") {
      return <Check style={{ color: "#42BDAE" }} />;
    }

    if (error === "loading") {
      return <CircularProgressStyled size={24} />;
    }

    return <Close style={{ color: "#D20E0E" }} />;
  }, [error]);

  const getIconPosition = useCallback(() => {
    if (icon && icon.direction) {
      if (icon.direction === "end") return "endAdornment";
      if (icon.direction === "start") return "startAdornment";
    }
  }, [icon]);

  const objIcon = useMemo(() => {
    if (type === "password") {
      return {
        endAdornment: (
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            edge="end"
          >
            {values.showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        ),
      };
    }

    if (icon) {
      return { [`${getIconPosition()}`]: icon.icon };
    }

    if (error) {
      return { [`endAdornment`]: <IconInput /> };
    }

    return {};
  }, [
    type,
    icon,
    error,
    handleClickShowPassword,
    values.showPassword,
    getIconPosition,
    IconInput,
  ]);

  const isDisabled = useMemo(() => {
    if (disabled) {
      return true;
    }

    if (error === "loading") {
      return true;
    }

    return disabled;
  }, [disabled, error]);

  return (
    <InputContainer>
      {labelText && <InputLabel enabled={enabled}>{labelText}</InputLabel>}
      {/* <InputMask mask="(0)999 999 99 99">
        {() => <InputStyled InputProps={objIcon} {...handler} disabled={!enabled} />}
      </InputMask> */}

      <InputMask
        mask={mask ? mask : ""}
        // inputRef={inputRef}
        onChange={onChange}
        type="text"
        disabled={isDisabled}
        maskPlaceholder={null}
        onKeyPress={onKeyPress}
        onBlur={onBlur}
      >
        {() => (
          <InputStyled
            InputProps={objIcon}
            {...handler}
            filled={error === "success" && isDisabled}
            disabled={isDisabled}
            placeholder={placeholder ? placeholder : mask}
            onChange={onChange}
            inputProps={{ maxLength: maxLength }}
            inputRef={inputRef}
            type={
              type !== "password" || values.showPassword ? "text" : "password"
            }
            onBlur={onBlur}
          />
        )}
      </InputMask>
      {!!error && error !== "success" && error !== "loading" && <p>{error}</p>}
    </InputContainer>
  );
};
